<template>
  <v-app
    :style="{ 'background-color': $vuetify.theme.themes['dark'].background }"
  >
    <div>
      <template>
        <v-snackbar
          app
          top
          :value="updateExists"
          :timeout="timeout"
          color="blue"
          :elevation="elevation"
          :outlined="outlined"
          :centered="centered"
        >
          Une mise à jour de l'Application est déployée
          <v-btn rounded @click="refreshApp" color="warning">
            <v-icon left dark>mdi-reload</v-icon>
            Mettre à jour
          </v-btn>
        </v-snackbar>
      </template>
      <Snackbar />
      <Loading />
      <InstallPrompt />
      <template>
        <div>
          <vue-headful :title="parametres.AppName" />
        </div>
      </template>

      <div v-if="isAuthenticated" class="login">
        <v-navigation-drawer dark v-model="drawer" app temporary v-if="isAdmin">
          <div justify="center" align="center">
            <v-avatar color="indigo" class="mt-6">
              <v-icon dark to="/profil">mdi-account-circle</v-icon>
            </v-avatar>
            <div v-if="isAuthenticated" class="white--text">
              <span class="mr-2">{{ utilisateur.displayName }}</span>
            </div>
            <div v-if="isSuperAdmin" class="white--text">
              <span class="mr-2">Super Administrateur</span>
            </div>
            <div v-if="isAdmin" class="white--text">
              <span class="mr-2">Administrateur</span>
            </div>
            <div v-if="isSuperviseur" class="white--text">
              <span class="mr-2">Superviseur</span>
            </div>
            <div v-if="isGroupe" class="white--text">
              <span class="mr-2">Groupe</span>
            </div>
          </div>
          <template>
            <v-list>
              <v-list-item to="/">
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Accueil</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list>
              <v-list-group
                v-for="item in menus"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.icon"
                no-action
                color="white"
              >
                <template v-slot:activator>
                  <v-list-item-content dark>
                    <v-list-item-title
                      v-text="item.title"
                      color="white"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="subItem.route"
                >
                  <v-list-item-icon>
                    <v-icon v-text="subItem.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="subItem.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </template>
          <template>
            <!-- <div class="pa-2">
              <v-btn block @click.prevent="userSignOut" dark
                >{{ $lang.logout }}
                <v-icon right dark>mdi-exit-to-app</v-icon></v-btn
              >
            </div> -->
          </template>
        </v-navigation-drawer>
        <v-app-bar
          :clipped-left="clipped"
          fixed
          app
          flat
          dark
          class="background"
        >
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="isAdmin" />
          <Pending />
          <!--   <v-btn icon @click.stop="$router.go(-1)">
            <v-icon>mdi-arrow-left-circle-outline</v-icon>
          </v-btn> -->
          <!--  <v-btn icon @click.stop="$router.go(0)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn> -->
          <!--  <v-btn icon @click.stop="$router.go(1)">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
          </v-btn> -->
          <v-spacer />
          {{ user.displayName }}
          <v-spacer />

          <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline"
          >
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
              <v-btn icon x-large to="/profil">
                <v-icon>mdi-account-circle-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
              <v-btn x-large icon to="/profil">
                <v-icon>mdi-account-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-offline>
          <v-btn v-if="isAdmin" x-large icon to="/Reglages">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
        <v-main>
          <v-container fluid>
            <v-card min-width="300px" class="elevation-0 transparent">
              <router-view />
            </v-card>
          </v-container>
        </v-main>

        <!-- <v-footer :fixed="fixed" app dark class="primary d-none d-md-inline-block">
          <v-spacer></v-spacer>
          <span>{{ parametres.AppName }} {{ new Date().getFullYear() }}</span>
        </v-footer> -->
      </div>
      <div v-else class="login">
        <Login />
      </div>
    </div>
  </v-app>
</template>
<script>
import { mapState, mapActions } from "vuex";
import VOffline from "v-offline";
import update from "./mixins/update";

export default {
  mixins: [update],
  data() {
    return {
      elevation: 0,
      centered: true,
      timeout: "-1",
      outlined: false,
      onLine: null,
      onlineSlot: "online",
      offlineSlot: "offline",
      utilisateur: { displayName: "" },
      clipped: false,
      drawer: false,
      fixed: true,
    };
  },
  components: {
    VOffline,
    Login: require("./pages/Login.vue").default,
    Snackbar: require("./components/Snackbar.vue").default,
    Loading: require("./components/Loading.vue").default,
    Pending: require("./components/Pending.vue").default,
    InstallPrompt: require("./components/InstallPrompt.vue").default,
  },
  methods: {
    amIOnline(e) {
      this.onLine = e;
      console.log("online : " + e);
      this.setOnlineState(e);
    },
    getCurrentUSer() {
      this.utilisateur = this.user;
    },

    userSignOut() {
      this.userLogOut();
      this.drawer = false;
    },

    ...mapActions({
      setParametres: "Parametres/realitimeListenerParametres",
      userLogOut: "Auth/userSignOut",
      setOnlineState: "Online/setOnlineState",
      startBusyState: "Loading/startBusyState",
      stopBusyState: "Loading/stopBusyState",
      resetnavigationState: "Navigation/resetnavigationState",
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetAllTypeDetailsEtape: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      getMyGroupes: "Mygroupes/GetAll",
      getMyHorsGroupe: "HorsGroupe/GetAll",
      GetActivites: "Activites/GetAll",
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      GetCommunesDuSuperviseurApartirDeDistricts:
        "Communes/GetCommunesDuSuperviseurApartirDeDistricts",
      GetFokontanyDuSuperviseurApartirDeDistricts:
        "Fokontany/GetFokontanyDuSuperviseurApartirDeDistricts",
      GetCampagnes: "Campagnes/GetAll",
      GetCampagneActive: "Campagnes/GetCampagneActive",

      getEtapes: "Etapes/GetAll",
      getDetailEtapes: "DetailEtapes/GetAll",
      getDistricts: "Districts/GetAll",
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
      GetThemes: "Themes/GetAll",
    }),
  },
  created() {
    this.resetnavigationState();
    this.setParametres();
    if (this.user.districts) {
      if (this.user.districts.length != 0) {
        this.GetCommunesDuSuperviseurApartirDeDistricts(
          this.listeDistrictsDuSuperviseur
        );
        this.GetFokontanyDuSuperviseurApartirDeDistricts(
          this.listeDistrictsDuSuperviseur
        );
      }
    }
    
  },

  computed: {
    ...mapState({
      localStorageSize: (state) => state.Utils.localStorageSize,
      parametres: (state) => state.Parametres.parametres,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      user: (state) => state.Auth.user,
      users: (state) => state.Users.users,
      showSnackbar: (state) => state.Snackbar.showSnackbar,
      snackbarContent: (state) => state.Snackbar.snackbarContent,
      menus: (state) => state.Navigation.MainNavigation,
    }),
  },
};
</script>
<style>
html {
  overflow-y: auto !important;
}

/* #contain {
   max-width: 1200px; 
} */

/* .v-application {
  background-color: #dddddd !important;
} */

.v-card-login {
  border-radius: 16px !important;
}
.v-card,
.v-expansion-panels {
  border-radius: 16px !important;
}

.offline {
  background-color: #fc9842;
  background-image: linear-gradient(315deg, #fc9842 0%, #fe5f75 74%);
  border-radius: 50px;
}
/* .online {
  background-color: #00b712;
  background-image: linear-gradient(315deg, #00b712 0%, #5aff15 74%);
} */

.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 23px !important;
}
.v-application--is-ltr .v-list-item__icon {
  margin-right: 11px !important;
}
.project {
  border-left: 4px solid #009933;
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 10px;
  border-bottom: 1px solid #009933;
}

.image-div {
  display: flex;
  margin: 25px;
  background-color: #ccc;
}

.hidden {
  display: none;
}
.theme--dark.v-card > .v-card__text,
.theme--dark.v-card .v-card__subtitle {
  color: rgba(255, 255, 255, 1) !important;
}
.activeNavigation {
  border-bottom: 4px solid #009933 !important;
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.1s;
}

.fade-enter-active {
  transition-delay: 0.1s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.v-list-item__title,
.v-list-item__content,
.v-card {
  text-align: left !important;
}
.fabNav {
  bottom: 80px !important;
  right: 4px !important;
}
.v-tabs-bar {
  border-bottom: 1px solid #cccccc !important;
}

.v-list-item {
  border-bottom: 1px solid #cccccc !important;
}
.neumorphic,
.neumorphicCard {
  box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.25),
    -2px -2px 5px 0 rgba(255, 255, 255, 0.3) !important;
}
.neumorphic:active {
  box-shadow: inset 2px 2px 5px 0 rgba(0, 0, 0, 0.25),
    inset -2px -2px 5px 0 rgba(255, 255, 255, 0.3) !important;
}

.small-screen-only,
.large-screen-only {
  display: none;
}

@media only screen and (max-width: 974px) {
  .large-screen-only {
    display: none;
  }
  .small-screen-only {
    display: block;
  }
}

@media screen and (min-width: 975px) {
  .large-screen-only {
    display: block;
  }
  .small-screen-only {
    display: none;
  }
}
</style>
